import React from 'react';
export function SiteFooter() {
  return <footer className="bg-sand py-14" data-id="element-194" data-mp="348oflv2iyool">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-195" data-mp="1t75g0bzhurfv">
        <p className="font-serif text-2xl font-bold text-ink" data-id="element-196" data-mp="1t5knst0njkl6">
          Reforms <span className="italic text-gold" data-id="element-197" data-mp="1o8u4lwtjw8vj">Without</span> Renovation
        </p>
        <p className="mx-auto mt-4 max-w-xl leading-relaxed text-body" data-id="element-198" data-mp="1j9h9kosizvhv">
          A digital library with 101 practical solutions for refreshing different areas of your home before turning to a traditional renovation.
        </p>
        <p className="mt-3 font-semibold text-ink" data-id="element-199" data-mp="2bxwmn5s3k3qk">Less guesswork. More clarity to decide what to change and how to do it.</p>
        <div className="mt-10 border-t border-ink/10 pt-6 text-xs leading-relaxed text-body" data-id="element-200" data-mp="270d8e5vefqym">
          <p data-id="element-201" data-mp="22yrq2503ikh1">© 2026 — Reforms Without Renovation | All Rights Reserved.</p>
          <p className="mt-1" data-id="element-202" data-mp="vjwsycjuhabr">This is a digital product delivered in PDF format. No physical product will be shipped.</p>
        </div>
      </div>
    </footer>;
}